import type { JSX, ReactNode, Ref } from 'react'
import type { FIXED_INDENTS, INDENTS } from 'vars/index'
import type { LAYOUT } from 'vars/layout-settings'
import type {
  Colors,
  TextBoxTypes,
  TextDecoration,
  WordBreak,
} from './TextBox.h'

import { TextAligning, TextTransform } from './TextBox.h'
import { TextBoxSC } from './TextBox.styled'

export interface ITextBoxProps {
  ref?: Ref<HTMLSpanElement>
  font?: TextBoxTypes
  title?: string
  daysTitle?: string
  hoursTitle?: string
  minutesTitle?: string
  secondsTitle?: string
  maxLines?: number
  color?: Colors
  textTransform?: TextTransform
  width?: string
  alignment?: TextAligning
  className?: string
  horizontalPaddings?: LAYOUT | FIXED_INDENTS | INDENTS
  verticalPaddings?: LAYOUT | FIXED_INDENTS | INDENTS
  children?: ReactNode | ReactNode[]
  verticalGap?: FIXED_INDENTS
  textDecoration?: TextDecoration
  preWrap?: boolean
  dataTestId?: string
  wordBreak?: WordBreak
}

/**
 * @warn children here could be ONLY ANOTER TextBoxes(!!!!!!!) with different  fonts or colors
 */

export function TextBox({
  ref,
  font,
  title,
  maxLines,
  color,
  textTransform = TextTransform.None,
  width,
  alignment = TextAligning.Left,
  className,
  horizontalPaddings,
  verticalPaddings,
  children,
  verticalGap,
  textDecoration,
  preWrap,
  dataTestId,
  wordBreak,
}: ITextBoxProps): JSX.Element {
  return (
    <TextBoxSC
      ref={ref}
      font={font}
      maxLines={maxLines}
      colorDefault={color}
      textTransform={textTransform}
      width={width!}
      alignment={alignment}
      className={className}
      horizontalPaddings={horizontalPaddings}
      verticalPaddings={verticalPaddings}
      verticalGap={verticalGap}
      textDecoration={textDecoration}
      preWrap={preWrap}
      data-testid={dataTestId}
      wordBreak={wordBreak}
    >
      {children || title}
    </TextBoxSC>
  )
}
